<template>
  <Head title="Admin - Manage Client Documents" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center px-4">
        <div class="col-12">
          <manage-client-documents :client="client"></manage-client-documents>                   
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

const props = defineProps({
  client: Object,
  lockstep: Object
});

// Set window global immediately so it's available when components mount
window.__LOCKSTEP__ = props.lockstep;
</script>

